import { render } from "./fb-checkbox.svg?vue&type=template&id=460ce406"
const script = {}
script.render = render

export default script